import { BasketballGame, User } from '@hefe/models';

interface Props {
  game?: BasketballGame;
  user?: User;
}

export const useUserBasketballGameRoles = (props: Props) => {
  const { game, user } = props;

  let userIsCoach = false;

  if (game && user) {
    const teamIds = props.game?.team_details?.map((td) => td.team_id);
    const userCoachTeamIds = user?.basketball_user?.coached_teams?.map(
      (t) => t.id
    );
    userIsCoach =
      teamIds?.some((id) => userCoachTeamIds?.includes(id)) ?? false;
  }

  return { userIsCoach };
};
